module.exports = __webpack_public_path__ + "static/media/featured-stone.ae855e21.svg";